module.exports = __webpack_public_path__ + "static/media/pin-warning-privado.53bc9909.png";